import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SearchBanner() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submit = () => {
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <section className="px-4 md:px-6 -mt-10 md:-mt-14 relative z-20">
      <div className="rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-7">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8">
          <div className="lg:w-1/3">
            <h2 className="font-heading font-semibold text-xl md:text-2xl text-foreground-950">
              找到你想看的影视作品
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              支持按名称、主演与类型模糊搜索
            </p>
          </div>
          <form
            className="flex-1 flex flex-col sm:flex-row gap-3"
            onSubmit={(event) => {
              event.preventDefault();
              submit();
            }}
          >
            <div className="flex-1 flex items-center gap-2 h-12 px-4 rounded-md border border-background-300 focus-within:border-primary-400 bg-background-50">
              <i className="ri-search-line text-lg text-foreground-500"></i>
              <input
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="输入影视名称，如：顽皮的女朋友"
                className="flex-1 h-full bg-transparent outline-none text-sm text-foreground-950 placeholder:text-foreground-400"
              />
            </div>
            <button
              type="submit"
              className="h-12 px-6 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-heading text-sm tracking-wide hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即搜索
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}